module.exports = __webpack_public_path__ + "img/learner-quiz-Moose-Q4.1dcc57ce.png";